import React, {PureComponent} from 'react';
import DatePicker from 'react-datepicker';
import MinusIcon from 'mdi-react/MinusIcon';
import CalendarBlankIcon from 'mdi-react/CalendarBlankIcon';
import PropTypes from 'prop-types';
import moment from 'moment';

class IntervalDatePickerField extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            start: props.defaultDate,
            end: props.defaultDate
        };
        this.props.onChange({start: props.defaultDate, end: props.defaultDate});
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange({start, end}) {
        start = start || this.state.start;
        end = end || this.state.end;

        if (start && start.isAfter(end)) {
            end = start
        }

        this.setState({start, end});
        this.props.onChange({start, end: end});
    }

    handleChangeStart = (start) => this.handleChange({start});

    handleChangeEnd = (end) => this.handleChange({end});

    render() {
        return (
            <div>
                <div className='date-picker date-picker--interval'>
                    <DatePicker
                        selectsStart
                        startDate={this.state.start}
                        filterDate={this.props.filterDate}
                        endDate={this.state.end}
                        onChange={this.handleChangeStart}
                        selected={this.props.value.start ? moment(this.props.value.start) : null}
                        placeholderText='Desde'
                        dateFormat='DD/MM/YYYY'
                    />
                    <div className='date-picker-group-icon form__form-group-icon'>
                        <CalendarBlankIcon/>
                    </div>
                    <MinusIcon className='date-picker__svg'/>
                    <DatePicker
                        selectsEnd
                        startDate={this.state.start}
                        filterDate={this.props.filterDate}
                        endDate={this.state.end}
                        onChange={this.handleChangeEnd}
                        selected={this.props.value.end ? moment(this.props.value.end) : null}
                        dateFormat='DD/MM/YYYY'
                        placeholderText='Hasta'
                    />
                    <div className='date-picker-group-icon form__form-group-icon'>
                        <CalendarBlankIcon/>
                    </div>
                </div>
            </div>
        )
    }
}

const renderIntervalDatePickerField = (props) => (
    <div>
        <IntervalDatePickerField
            {...props.input}
            filterDate={props.filterDate}
            defaultDate={props.defaultDate}
        />

        {props.meta.error && <span className='form__form-group-error'>{props.meta.error}</span>}
    </div>
);

renderIntervalDatePickerField.propTypes = {
    input: PropTypes.object.isRequired
};

export default renderIntervalDatePickerField;


// WEBPACK FOOTER //
// ./src/theme/components/form/IntervalDatePicker.js